import React, { useState, useEffect } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import EscReportTable from "./EscReportTable";
import useLogout from "../../hooks/useLogout";
import { useNavigate } from "react-router-dom";

const EscBreakdownReport = () => {
  const logout = useLogout();
  const navigate = useNavigate();
  const [ticketDetails, setTicketDetails] = useState(false);
  const axiosPrivate = useAxiosPrivate();
  const [filterError, setFilterError] = useState(false);
  const [project, setProject] = useState("last_ten_escalations");
  const [quarter, setQuarter] = useState("quarter");
  const [superArea, setSuperArea] = useState("super_area");
  const [segment, setSegment] = useState("supportLevel");
  const [year, setYear] = useState("year");
  const currentYear = new Date().getFullYear();
  const startYear = 2022;
  const years = Array.from({ length: currentYear - startYear + 1 }, (_, i) => startYear + i);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const getRecentEscalations = async () => {
      try {
        const response = await axiosPrivate.get('/report', {
          signal: controller.signal
        });
        if (isMounted) setTicketDetails(response.data);
      } catch (err) {
        if (err.message !== 'canceled') {
          await logout();
          navigate('/login');
        }
      }
    };

    getRecentEscalations();

    return () => {
      isMounted = false;
      controller.abort();
    };
    // eslint-disable-next-line
  }, []);

  const handleFilter = async () => {
    try {
      setFilterError(false);
      if (project === 'last_ten_escalations') {
        setYear("year");
        setQuarter("quarter");
        setSuperArea("super_area");
        return getEscalationsTickets();
      } else if (year === 'year') {
        return setFilterError("Please select the valid Year");
      }

      getEscalationsTickets();
    } catch (err) {
      if (err.message !== 'canceled') {
        await logout();
      }
    }
  };

  const getEscalationsTickets = async () => {
    try {
      setTicketDetails(false);
      let url = `/report?project=${project}&year=${year}`;

      if (quarter !== 'quarter') {
        url += `&quarter=${quarter}`;
      }
      if (superArea !== 'super_area') {
        url += `&superArea=${superArea}`;
      }
      if (segment !== 'supportLevel') {
        url += `&segment=${segment}`;
      }

      const response = await axiosPrivate.get(url);
      if (response.data.msg) return setTicketDetails({});
      setTicketDetails(response.data);
    } catch (err) {
      if (err.message !== 'canceled') {
        await logout();
      }
    }
  };

  return (
    <EscReportTable
      project={project}
      handleFilter={handleFilter}
      ticketDetails={ticketDetails}
      setProject={setProject}
      filterError={filterError}
      years={years}
      setYear={setYear}
      setQuarter={setQuarter}
      setSuperArea={setSuperArea}
      setSegment={setSegment}
    />
  );
};

export default EscBreakdownReport;
